import i18n from '@/locales'

export const KAFKA_STORAGE = {
  cloud_efficiency: i18n.t('middleware.cloud_efficiency'),
  cloud_ssd: i18n.t('middleware.cloud_ssd'),
}
